export default "__VITE_ASSET__fc88f8bf__"